<!--  -->
<template>
  <div id="Home" style="position: relative;">
    <!-- 暂时废弃 -->
    <!-- <div class="select">
      <div class="select_item" v-for="item in mapList" :key="item.index" @click.stop="changeList(item)">
        <p class="name" :class="item.type==currenIndex?'active':''">{{item.name}}</p>
      </div>
    </div> -->
    <div class="home_top flex align-center"
      style="position: absolute;left: 50%;transform: translateX(-50%);"
      :style="{top: isChongHuanDian ? '129px' : '0'}">
      碳减排量
      <div class="home_number margin-left-xs margin-right-xs" v-for="(i,index) in carbonReduction" :key="index">{{i}}</div>
      cc
    </div>
    <component :is="currenIndex" v-cloak />
  </div>
</template>

<script>
  import sctterMap from '@/components/sctterMap'
  import dotMap from '@/components/dotMap'
  import heatMap from '@/components/heatMap'
  import allMap from "@/components/allMap"
  import { dataInterface } from '@/api/dataInterfaceApi';

  export default {
    name: 'home',
    components: {
      sctterMap,
      dotMap,
      heatMap,
      allMap,
    },
    data() {
      return {
        carbonReduction:[],
        currenIndex: 'sctterMap',
        mapList: [{
            type: 'sctterMap',
            name: '分布图',
            index: 1,
          },
          {
            type: 'heatMap',
            name: '热力图',
            index: 2,
          },
          {
            type: 'dotMap',
            name: '散点图',
            index: 3,
          },
          {
            type: 'allMap',
            name: '综合地图',
            index: 4,
          },
        ],
      }
    },
	computed: {
		isChongHuanDian() {
			let { name } = this.$route
      let whiteList = ['changingElectricity', 'changingElectricityMerge', 'changingElectricityProvince', 'changingElectricityCity', 'changingElectricityDistrict']
			return whiteList.includes(name) // 是否是充换电地址
		}
	},
    mounted() {
    },
    methods: {
      changeList(val) {
        console.log(val.type,'地图类型')
        if (val.type == this.currenIndex) {
          return
        }
        this.currenIndex = val.type
      },
      getData(data){
        this.selectComprehensiveSituation(data);
      },
      //综合态势
      selectComprehensiveSituation(data={}){
        let _this = this;
        const { query } = this.$route
        if(query.token) localStorage.setItem('uid',query.token )
        let params = {
        "enCode":"hdz-zhts",
        "@province":data.province||data.city||data.district || '000000',
        '@uid': localStorage.getItem('uid') || '000000'
      }

        dataInterface
          .dataFaceApiXZ(params)
          .then((res) => {
            // console.log(res,'ljtjpljtjpljtjp')
            if(!res) return;
            let { ljtjp } = res[0] || {}
            console.log(ljtjp,'ljtjpljtjpljtjp')
            _this.carbonReduction = ljtjp && ljtjp.toString().split(".")[0] || '';
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  }
</script>
<style lang="scss" scoped>
  #Home {
    width: 100%;
    height: 100%;
    position: relative;
    .select {
      position: absolute;
      left: 1%;
      top: 15%;
      z-index: 15;

      .select_item {
        padding: 6px 25px;
        color: rgb(179, 239, 255);
        background: rgba(147, 235, 248, .35);
        border-radius: 15px;
        margin: 25px 0;
        cursor: pointer;

        .active {
          color: rgb(254, 217, 50);
        }
      }
    }
    .home_top{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      z-index: 15;
      font-size: 32px;
    }
    .home_number{
      width:70px;
      height:76px;
      line-height: 76px;
      font-size:60px;
      font-family: 'DS-Digital-Bold';
      color:#00FDF4;
      text-align: center;
      background-image: linear-gradient(45deg, rgba(35,94,92,0.00) 0%, rgba(69,196,190,0.60) 48%, rgba(36,98,96,0.03) 100%, rgba(35,94,92,0.00) 100%);
      border-radius: 6px;
      border-radius: 6px;
    }
  }
</style>